import { PermissionSetType } from './sets'

export enum PermissionUpdateType {
  Grant = 'grant',
}

export interface IGrantPermissionUpdate {
  rolesWith: PermissionSetType
  grant: PermissionSetType[]
}

export interface IPermissionUpdate {
  key: string
  description: string
  type: PermissionUpdateType
  update: IGrantPermissionUpdate
}
